import {sanitizeString} from "../Apis/functions";

export const Supplier = {
    acronym: '',
    address: '',
    comment: null,
    supplierCompanyName: '',
    supplierStatusId: '',
    createdAt: null,
    description: '',
    deviceId: null,
    dob: null,
    email: null,
    firebaseId: null,
    genderId: '',
    id: null,
    lastName: '',
    name: '',
    password: null,
    phoneNumber: '',
    secondLastName: '',
    selfie: null,
    statusId: '',
    updatedAt: null,
    userId: null,
    documentId: '',
    serviceTypeId: '',

    toCreateUpdate: function (password, extraData) {
        return {
            acronym: this.acronym,
            address: this.address !== '' ? this.address : null,
            supplierCompanyName: this.supplierCompanyName,
            supplierStatusId: this.supplierStatusId !== '' ? this.supplierStatusId : null,
            description: this.description !== '' ? this.description : null,
            dob: this.dob === null ? null : typeof this.dob === 'number' ? this.dob : this.dob.getTime(),
            email: this.email,
            genderId: this.genderId !== '' ? this.genderId : null,
            id: this.id,
            lastName: this.lastName,
            name: this.name,
            phoneNumber: this.phoneNumber,
            secondLastName: this.secondLastName !== '' ? this.secondLastName : null,
            statusId: this.statusId !== '' ? this.statusId : null,
            userId: this.userId,
            documentId: this.documentId,
            serviceTypeId: this.serviceTypeId,
            password: password,
            extraData: extraData
                ? {
                    field1: sanitizeString(extraData.field1),
                    field2: sanitizeString(extraData.field2),
                    field3: sanitizeString(extraData.field3),
                    field4: sanitizeString(extraData.field4),
                    field5: sanitizeString(extraData.field5),
                    field6: sanitizeString(extraData.field6),
                    field7: sanitizeString(extraData.field7),
                    field8: sanitizeString(extraData.field8),
                    field9: sanitizeString(extraData.field9),
                    field10: sanitizeString(extraData.field10),
                    field11: sanitizeString(extraData.field11),
                    field12: sanitizeString(extraData.field12),
                    field13: sanitizeString(extraData.field13),
                    field14: sanitizeString(extraData.field14),
                    field15: sanitizeString(extraData.field15),
                    id: extraData.id,
                    userId: extraData.userId,
                }
                : null,
        };
    },
    isValid: function (){
        return this.acronym &&
            this.supplierCompanyName &&
            this.name &&
            this.lastName &&
            this.phoneNumber &&
            this.documentId &&
            this.serviceTypeId;
    },
    isValidCompanyDetails: function (){
        return this.acronym && this.supplierCompanyName && this.serviceTypeId
    },
    isValidManagerDetails: function (){
        return this.name &&
            this.lastName &&
            this.documentId &&
            this.email &&
            this.phoneNumber;
    },
    clearCompanyDetails: function (){
        return {
            ...this,
            acronym: '',
            supplierCompanyName: '',
            address: '',
            serviceTypeId: '',
            description: ''
        }
    },
    clearManagerDetails: function (){
        return {
            ...this,
            name: '',
            lastName: '',
            secondLastName: '',
            documentId: '',
            email: '',
            phoneNumber:'',
            genderId:'',
            dob: null,
            password:''
        }
    }
};
